import { RS_API_URI } from "@api/session";

import { queryString, sessionPrefix } from "./helpers";

export const jobsPath = (session: LightSessionInterface, args: QueryStringType = null) =>
  `${sessionPrefix(session)}/jobs${queryString(args)}`;
export const showJobPath = (session: LightSessionInterface, job: JobResultRef, args = {}) =>
  `${sessionPrefix(session)}/jobs/${job.id}${queryString(args)}`;

export const jobDownloadPath = (job: JobResultRef) => `${RS_API_URI}/jobs/${job.id}`;
